// test2172
(2172 && 0);
